/**
 * Instancia conectada
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class ConnectedUnigestInstance {
    public id = ''
    public status: 'CONNECTED' | 'DISCONNECTED' | 'INACTIVE' = 'CONNECTED'
    public appVersion = ''
    public apiURL = ''
    public emittedAt = new Date()
    public wampSession = 0
    public currentPath = ''

    public user = {
        id: '',
        name: '',
    }

    public deviceInfo = {
        os: '',
        osVersion: '',
        browser: '',
        browserVersion: '',
        device: '',
        width: 0,
        height: 0,
        memory: 0,
    }

    public get shortedAPIURL () {
        const url = new URL(this.apiURL)

        return `:${url.port}/${url.pathname}`
    }

    /**
     * Realiza una búsqueda por ocurrencia de termino argumentado.
     * Compara la búsqueda con todos los campos de texto además
     * del id.
     *
     * @param search
     */
    public includes (search: string) {
        return this.user.name.includes(search)
            || this.appVersion.includes(search)
            || this.user.id.toString().includes(search)
            || this.apiURL.includes(search)
            || this.currentPath.includes(search)
    }
}
